var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.className,style:({height:_vm.height,width:_vm.width})},[_c('div',{staticStyle:{"height":"400px"},attrs:{"id":"ConventionChart"}})])}
var staticRenderFns = []

export { render, staticRenderFns }